import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CaretUpIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CaretUpIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 11">
      <g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 20 11)">
        <path d="M10 11a2.222 2.222 0 01-1.446-.531L.776 3.871A2.186 2.186 0 01.535.768 2.243 2.243 0 013.669.53L10 5.9 16.331.53a2.239 2.239 0 013.134.238 2.186 2.186 0 01-.241 3.1l-7.778 6.6A2.222 2.222 0 0110 11z" />
      </g>
    </Icon>
  )
}
export default CaretUpIcon
